<!--
Auto-generated by: https://github.com/threlte/threlte/tree/main/packages/gltf
Command: npx @threlte/gltf@2.0.3 /Users/nrumak/Development/square-dt-labs/static/nrumak/laptop_modified.glb -u -t -P
-->

<script module lang="ts">
  import { Group, Material, Mesh } from 'three';
  import { T, type Props } from '@threlte/core';
  import { useGltf, useSuspense } from '@threlte/extras';
  import type { Snippet } from 'svelte';

  type GLTFResult = {
    nodes: {
      Mesh343: Mesh;
      Mesh343_1: Mesh;
      Mesh343_2: Mesh;
      Mesh343_3: Mesh;
    };
    materials: {};
  };

  let modelUrl = '';

  const load = () => {
    const suspend = useSuspense();
    return suspend(useGltf<GLTFResult>(modelUrl));
  };

  export const preload = async (url: string) => {
    modelUrl = url;
    try {
      await load();
    } catch (err) {
      return console.error('Failed to load model', err);
    }
  };
</script>

<script lang="ts">
  let {
    fallback,
    error,
    children,
    ref = $bindable(),
    matcaps,
    fallbackMaterial,
    ...props
  }: Props<Group> & {
    ref?: Group;
    matcaps: {
      frame: Material;
      blackKeys: Material;
      darkBlack: Material;
      laptop_screen: Material;
    };
    fallbackMaterial: Material;
    children?: Snippet<[{ ref: Group | undefined }]>;
    fallback?: Snippet;
    error?: Snippet<[{ error: Error }]>;
  } = $props();

  let materials: any = $state(matcaps);

  $effect(() => {
    materials = matcaps ?? {
      frame: fallbackMaterial,
      blackKeys: fallbackMaterial,
      darkBlack: fallbackMaterial,
      laptop_screen: fallbackMaterial,
    };
  });

  const gltf = load();
</script>

<T is={new Group()} dispose={false} {...props}>
  {#await gltf}
    {@render fallback?.()}
  {:then gltf}
    <T.Group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
      <T.Mesh geometry={gltf.nodes.Mesh343.geometry} material={materials.laptop_screen} />
      <T.Mesh geometry={gltf.nodes.Mesh343_2.geometry} material={materials.frame} />
      <T.Mesh geometry={gltf.nodes.Mesh343_1.geometry} material={materials.blackKeys} />
      <T.Mesh geometry={gltf.nodes.Mesh343_3.geometry} material={materials.darkBlack} />
    </T.Group>
  {:catch err}
    {@render error?.({ error: err })}
  {/await}
  {@render children?.({ ref })}
</T>
